"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PLANE = exports.KEYBOARD_QUICK_CHANGE = exports.MOUSE_QUICK_CHANGE = exports.MAX_INPUT_VALUE = void 0;
var types_1 = require("./types");
exports.MAX_INPUT_VALUE = 9999;
exports.MOUSE_QUICK_CHANGE = '$globalMouseQuickChange';
exports.KEYBOARD_QUICK_CHANGE = '$globalKeyboardQuickChange';
exports.DEFAULT_PLANE = types_1.StylePanelPlane.Vertical;
//# sourceMappingURL=consts.js.map